export default {
  namespaced: true,
  intelbras: {
    title: "Intelbras",
    name: "Nombre",
    panel_model: "Modelo del Panel",
    panel: "Panel",
    panels: "Paneles",
    host: "Host",
    port: "Puerto",
    client_password: "Contraseña del Cliente",
    remote_control_password: "Contraseña de Control Remoto",
    listening_port: "Puerto de Escucha",
    facilities: "Instalaciones",
    event_code: "Código de Evento",
    alarm_type_sbo: "Tipo de Alarma (SBO)",
    description: "Descripción",
    zone: "Zona",
    num_conact_id: "Número de Cuenta de Contact ID",
    creation_date: "Fecha de Creación",
    date: "Fecha",
    masterAccounts: "cuentas maestras",
    masterAccount: "cuenta maestra",
    first_name: "nombre",
    last_name: "apellido",
    link: "enlace",
    username: "nombre de usuario",
    token: "token",
    password: "contraseña",
    token_expired: "expiración del token",
    email: "correo electrónico",
    sites: "sitios",
    site: "sitio",
    address: "dirección",
    latitude: "latitud",
    longitude: "longitud",
    timeZone: "zona horaria",
    profile: "perfil",
    profiles: "perfiles",
    calendar: "calendario",
    serialNumber: "número de serie",
    actions: "acciones",
    schemaTypes: "tipos de esquemas",
    schema_type: "tipo de esquema",
    display_name: "nombre para mostrar",
    id: "id",
    devices: "dispositivos",
    gateway_id: "id del gateway",
    schema_actions: "acciones del esquema",
    typeAlarm: "tipo de alarma",
    typeAlarms: "tipos de alarmas",
    priority: "prioridad",
    dispatchAlarm: "despacho de alarma",
    alarms: "alarmas",
    state: "estado",
    creation_time: "hora de creación",
    units: "instalaciones",
    center: "centro",
    sector: "sector",
    device: "dispositivo",
    schemaEvent: "evento",
    time: "hora",
    logs: "registros",
    channel: "canal",
    name_panel: "nombre del panel",
    events: "eventos",
    syncCorrectly: "sincronizados correctamente",
    status: "Estado",
    instance_host: "Host de la Instancia",
    rules: "Reglas",
    code: "Código",
    event: "Evento",
    event_id: "ID de Evento",
    value: "Valor",
    zones_pgm: "Zona / PGM",
    pgm_output: "PGM / Salida",
    partition: "Partición",
    alias: "Alias",
    syncDevices: "Sincronizar dispositivos",
    syncing: "Sincronizando",
    withoutProfile: "El panel no tiene perfil asignado",
    reconnect: "Reconectar",
    rebuild: "Reiniciar",
    profile_name: "Nombre del Perfil",
    type: "Tipo",
    active: "Activo",
    activate: "Activar",
    deactivate: "Desactivar",
    close: "Cerrar",
    open: "Abrir",
    bypass: "Anular",
    enable: "Habilitar",
    panelOffline: "El Panel esta fuera de línea",
    panelStatusArmed: "Armado",
    panelStatusDisarmed: "Desarmado",
    panelStatusOffline: "Fuera de línea",
    arm: "Armar",
    disarm: "Desarmar",
    arming: "Armando",
    disarming: "Desarmando",
    armedCorrectly: "Armado correctamente",
    disarmedCorrectly: "Desarmado correctamente",
    uuid: "UUID",
    connected: "Conectado",
    disconnected: "Desconectado",
  }
}
